import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { EditDriverPage } from "@/modules/drivers/EditDriverPage";
import { NewDriverPage } from "@/modules/drivers/NewDriverPage";
import { DriversOverviewPage } from "@/modules/drivers/OverviewPage";

/** Drivers module (DRIVERS.md §5): Overview (metrics + estate + read
 *  drawer) · New Driver (invite single/bulk) · Edit Driver (every mutation).
 *  Allocations joins when phase B (marriage ledger) lands. */
export function DriversModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/drivers" tabs={[
          { path: "overview", label: "Overview" },
          { path: "new", label: "New Driver" },
          { path: "edit", label: "Edit Driver" },
        ]} />
      </div>
      <Routes>
        <Route path="overview" element={<DriversOverviewPage />} />
        <Route path="new" element={<NewDriverPage />} />
        <Route path="edit" element={<EditDriverPage />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
